/* global PublicKeyCredential */
import axios from 'axios'; 
import { URL_BASE } from '../config/config';

export default {
    data() {
        return {
            loadingWebAuthn: false,
        };
    },
    methods: {
        // Função auxiliar para Base64
        toBase64WebAuthn(input) {
            let base64 = String(input);
            base64 = base64.replace(/-/g, '+').replace(/_/g, '/');
            const pad = base64.length % 4;
            if (pad) {
                base64 += '='.repeat(4 - pad);
            }
            return base64;
        },

        // --- REGISTRO (Tabela Users) ---
        async registerCredential(email) {
            this.loadingWebAuthn = true;
            try {
                // Endpoint ajustado: Sem "/financial"
                const { data } = await axios.post(`${URL_BASE}webauthn/register/options`, { email });
                
                data.attestation = "none"; 
                
                const options = PublicKeyCredential.parseCreationOptionsFromJSON(data);
                const credential = await navigator.credentials.create({ publicKey: options });

                const jsonResponse = credential.toJSON();
                
                const payload = {
                    id: jsonResponse.id,
                    rawId: jsonResponse.rawId,
                    type: jsonResponse.type,
                    response: {
                        attestationObject: this.toBase64WebAuthn(jsonResponse.response.attestationObject),
                        clientDataJSON: this.toBase64WebAuthn(jsonResponse.response.clientDataJSON),
                    },
                };

                // Endpoint ajustado: Sem "/financial"
                await axios.post(`${URL_BASE}webauthn/register`, payload);
                return true;
            } catch (error) {
                console.error('Erro no registro WebAuthn:', error);
                throw error;
            } finally {
                this.loadingWebAuthn = false;
            }
        },

        // --- AUTENTICAÇÃO (Tabela Users) ---
        async authenticateWithPasskey(email) {
            if (!email) throw new Error("O e-mail é obrigatório para autenticação.");

            this.loadingWebAuthn = true;
            try {
                // Endpoint ajustado: Sem "/financial"
                const { data } = await axios.post(`${URL_BASE}webauthn/login/options`, { email });
                
                const options = PublicKeyCredential.parseRequestOptionsFromJSON(data);
                const credential = await navigator.credentials.get({ publicKey: options });
                
                const jsonResponse = credential.toJSON();
                
                const payload = {
                    id: jsonResponse.id,
                    rawId: jsonResponse.rawId,
                    type: jsonResponse.type,
                    response: {
                        authenticatorData: this.toBase64WebAuthn(jsonResponse.response.authenticatorData),
                        clientDataJSON: this.toBase64WebAuthn(jsonResponse.response.clientDataJSON),
                        signature: this.toBase64WebAuthn(jsonResponse.response.signature),
                        userHandle: jsonResponse.response.userHandle 
                            ? this.toBase64WebAuthn(jsonResponse.response.userHandle) 
                            : null,
                    },
                };

                // Endpoint ajustado: Sem "/financial"
                await axios.post(`${URL_BASE}webauthn/login`, payload);
                return true;
            } catch (error) {
                console.error('Erro na autenticação WebAuthn:', error);
                throw error;
            } finally {
                this.loadingWebAuthn = false;
            }
        }
    }
};